// NOTE: Bridge
export const BRIDGE_CHAINS_QUERY_KEY = `bridge_getChains`;
export const BRIDGE_CRYPTOCURRENCIES_QUERY_KEY = `bridge_getCryptocurrencies`;
export const BRIDGE_TOKEN_FEE_QUERY_KEY = `bridge_getTokenFee`;
export const BRIDGE_TOKEN_TAX_QUERY_KEY = `bridge_getTokenTax`;
export const BRIDGE_HISTORIES_QUERY_KEY = `bridge_getHistories`;

export const BRIDGE_HISTORY_BY_ID_QUERY_KEY = `bridge_getHistory_interval`;
// NOTE: KSTADIUM
export const KSTADIUM_MY_BALANCE_QUERY_KEY = `kstadium_getBalance`;

export const KSTADIUM_TRANSACTION_STATE_WITH_TXHASH_QUERY_KEY = `kstadium_getTransactionStateWithTxHash`;
export const METAMASK_WALLET_MY_BALANCE_QUERY_KEY = `metamask_getBalance`;
